import React from 'react'
import './styles.scss'
import { useTranslation } from 'react-i18next'

export default function CompanyModal(props) {
  const { onSave, onCancel, onReset, title, description } = props
  const { t } = useTranslation()

  return (
    <div id="myModal" className="modal" onClick={props.close}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <span className="close" onClick={props.close}>
          {'&times;'}
        </span>
        <div>
          <h1>{title}</h1>
          <p>{description}</p>
          <div className="buttons-container">
            <button type="button" className="btn btn-outline-primary" onClick={onCancel}>
              {t('cancel')}
            </button>
            <div>
              <button type="button" className="btn btn-outline-primary" onClick={onReset}>
                {t('unsave')}
              </button>
              <button type="button" className="btn btn-primary" onClick={onSave}>
                {t('save')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
